import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cd7c8c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-investigation" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Investigation", -1))
const _hoisted_5 = {
  key: 0,
  class: "body-main has-indicator"
}
const _hoisted_6 = {
  key: 1,
  class: "body-main has-indicator"
}
const _hoisted_7 = {
  key: 0,
  class: "body-main"
}
const _hoisted_8 = { class: "investigation-form" }
const _hoisted_9 = { class: "ls-form" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "New investigation")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Select practice *", -1))
const _hoisted_12 = {
  class: "autocomplete",
  style: {"flex":"0 0 100%"}
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "icon-hm" }
const _hoisted_15 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_16 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_17 = {
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_18 = ["innerHTML", "onClick"]
const _hoisted_19 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type of investigation *", -1))
const _hoisted_22 = { class: "select-wrapper" }
const _hoisted_23 = { class: "select" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Select type", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigation category *", -1))
const _hoisted_29 = { class: "radio-group" }
const _hoisted_30 = { class: "radio" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Routine")
], -1))
const _hoisted_32 = { class: "radio" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text nowrap" }, "Cause driven")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Commencement date *", -1))
const _hoisted_35 = { class: "date-picker" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_37 = {
  key: 1,
  class: "validation-msg"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Select Investigator", -1))
const _hoisted_40 = { class: "select-wrapper" }
const _hoisted_41 = { class: "select" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Select investigator", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "controls mt-4" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_48 = {
  key: 0,
  class: "investigation-availability"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Availability", -1))
const _hoisted_50 = { class: "ls-table" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["colspan"]
const _hoisted_53 = { key: 1 }
const _hoisted_54 = ["colspan"]
const _hoisted_55 = { key: 2 }
const _hoisted_56 = ["colspan"]
const _hoisted_57 = { "data-label": "Name" }
const _hoisted_58 = {
  key: 0,
  class: "far fa-history pa-1"
}
const _hoisted_59 = { "data-label": "Routine Investigations" }
const _hoisted_60 = { "data-label": "Cause Driven Investigations" }
const _hoisted_61 = { "data-label": "Actions" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = {
  key: 1,
  class: "body-main grey-bg"
}
const _hoisted_64 = { class: "top-panel" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Availability", -1))
const _hoisted_66 = { class: "form-ctrl" }
const _hoisted_67 = { class: "select" }
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "buttons" }
const _hoisted_70 = { class: "bottom-panel" }
const _hoisted_71 = {
  key: 0,
  class: "ls-table"
}
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["colspan"]
const _hoisted_74 = { key: 1 }
const _hoisted_75 = ["colspan"]
const _hoisted_76 = { key: 2 }
const _hoisted_77 = ["colspan"]
const _hoisted_78 = { "data-label": "Practice name" }
const _hoisted_79 = { "data-label": "Commencement date" }
const _hoisted_80 = { "data-label": "Type" }
const _hoisted_81 = { "data-label": "Status" }
const _hoisted_82 = {
  key: 0,
  style: {"float":"right"}
}

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_NavigationBar = _resolveComponent("NavigationBar")
  const _component_CalendarView = _resolveComponent("CalendarView")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[16] || (_cache[16] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(!_ctx.editMode ? 'Add new investigation' : 'Finalize investigation'), 1),
          _hoisted_4
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.loadingContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_LoadingIndicator)
            ]))
          : (_ctx.errorLoadingContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_ErrorIndicator)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (!(_ctx.selectedDetailedInvestigator?.id > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("form", _hoisted_9, [
                          _createElementVNode("fieldset", null, [
                            _hoisted_10,
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives(_createElementVNode("input", {
                                onKeydown: [
                                  _cache[0] || (_cache[0] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                                  _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                                  _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                                ],
                                disabled: _ctx.editMode || _ctx.isFromRoutine,
                                class: "searchField",
                                type: "text",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.search) = $event)),
                                placeholder: "Search practice name or ID"
                              }, null, 40, _hoisted_13), [
                                [_vModelText, _ctx.search]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "hidden",
                                id: "practice",
                                name: "practice",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.currentSelectedPractice) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.currentSelectedPractice]
                              ]),
                              _createElementVNode("span", _hoisted_14, [
                                (_ctx.isSearching)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_16))
                              ]),
                              _withDirectives(_createElementVNode("ul", _hoisted_17, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practiceList, (practice, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: i,
                                    class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                                    innerHTML: _ctx.highlightWord(_ctx.formatPracticeText(practice)),
                                    onClick: _withModifiers($event => (_ctx.selectPractice(practice)), ["prevent"])
                                  }, null, 10, _hoisted_18))
                                }), 128))
                              ], 512), [
                                [_vShow, _ctx.isOpen]
                              ]),
                              (!_ctx.currentSelectedPractice)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _hoisted_20,
                                    _createTextVNode(" Mandatory field ")
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.formData.investigationType.id) = $event)),
                                  onChange: _cache[6] || (_cache[6] = $event => (_ctx.selectInvestigationType(_ctx.formData.investigationType.id)))
                                }, [
                                  _hoisted_24,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigationTypes, (iT) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: iT.id
                                    }, _toDisplayString(iT.name), 9, _hoisted_25))
                                  }), 256))
                                ], 544), [
                                  [_vModelSelect, _ctx.formData.investigationType.id]
                                ])
                              ])
                            ]),
                            (!_ctx.formData.investigationType.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _hoisted_27,
                                  _createTextVNode(" Mandatory field ")
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("label", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  id: "investigation-category",
                                  value: 1,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((this.formData.investigationCategory.id) = $event)),
                                  name: "investigation-category"
                                }, null, 512), [
                                  [_vModelRadio, this.formData.investigationCategory.id]
                                ]),
                                _hoisted_31
                              ]),
                              _createElementVNode("label", _hoisted_32, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  id: "investigation-category",
                                  value: 2,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((this.formData.investigationCategory.id) = $event)),
                                  name: "investigation-category"
                                }, null, 512), [
                                  [_vModelRadio, this.formData.investigationCategory.id]
                                ]),
                                _hoisted_33
                              ])
                            ]),
                            _hoisted_34,
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_v3_date_picker, {
                                class: "v3-date-picker",
                                modelValue: _ctx.commencementDate,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.commencementDate) = $event)),
                                style: {"padding":"1em"},
                                inputFormat: "dd-MM-yyyy",
                                lowerLimit: _ctx.disabledDates
                              }, null, 8, ["modelValue", "lowerLimit"]),
                              _hoisted_36
                            ]),
                            (!_ctx.commencementDate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _hoisted_38,
                                  _createTextVNode(" Mandatory field ")
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.formData.trustTeamMember.id) = $event))
                                }, [
                                  _hoisted_42,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigators, (i) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: i.id
                                    }, _toDisplayString(i.firstName) + " " + _toDisplayString(i.lastName), 9, _hoisted_43))
                                  }), 256))
                                ], 512), [
                                  [_vModelSelect, _ctx.formData.trustTeamMember.id]
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("button", {
                            class: "btn btn-default",
                            disabled: _ctx.submitting,
                            onClick: _cache[11] || (_cache[11] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
                          }, "Back", 8, _hoisted_45),
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
                            onClick: _cache[12] || (_cache[12] = _withModifiers($event => (_ctx.saveInvestigation()), ["prevent","stop"]))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.editMode ? 'Save investigation' : 'Save new investigation'), 1),
                            _hoisted_47
                          ], 8, _hoisted_46),
                          (_ctx.submitting)
                            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                                key: 0,
                                class: "loading-indicator",
                                showLoadingText: false
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.commencementDate && _ctx.currentSelectedPractice)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _hoisted_49,
                            _createElementVNode("table", _hoisted_50, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                                    return (_openBlock(), _createElementBlock("th", null, [
                                      _createElementVNode("p", null, _toDisplayString(h.text), 1)
                                    ]))
                                  }), 256))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_ctx.loadingTrustTeamMemberHistory)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                                      _createElementVNode("td", {
                                        colspan: _ctx.tableHeadings.length
                                      }, [
                                        _createVNode(_component_LoadingIndicator)
                                      ], 8, _hoisted_52)
                                    ]))
                                  : (_ctx.errorLoadingTrustTeamMemberHistory)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                                        _createElementVNode("td", {
                                          colspan: _ctx.tableHeadings.length
                                        }, [
                                          _createVNode(_component_ErrorIndicator)
                                        ], 8, _hoisted_54)
                                      ]))
                                    : (_ctx.investigators.length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                                          _createElementVNode("td", {
                                            colspan: _ctx.tableHeadings.length
                                          }, "No Records", 8, _hoisted_56)
                                        ]))
                                      : (_ctx.investigators.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.investigators, (aI) => {
                                            return (_openBlock(), _createElementBlock("tr", null, [
                                              _createElementVNode("td", _hoisted_57, [
                                                _createTextVNode(_toDisplayString(aI.firstName) + " " + _toDisplayString(aI.lastName) + " ", 1),
                                                (_ctx.investigatedPracticePreviously(aI))
                                                  ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_58, null, 512)), [
                                                      [_directive_tippy, { content: 'Investigated practice in the last 2 years' }]
                                                    ])
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_59, _toDisplayString(aI.totalRoutines), 1),
                                              _createElementVNode("td", _hoisted_60, _toDisplayString(aI.totalCauseDrivens), 1),
                                              _createElementVNode("td", _hoisted_61, [
                                                _createElementVNode("button", {
                                                  class: "btn btn-default transparent sml",
                                                  onClick: $event => (_ctx.viewDetailedInvestigator(aI))
                                                }, "View", 8, _hoisted_62)
                                              ])
                                            ]))
                                          }), 256))
                                        : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _hoisted_65,
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.selectedDetailedInvestigator) = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigators, (i) => {
                                return (_openBlock(), _createElementBlock("option", { value: i }, _toDisplayString(i.firstName) + " " + _toDisplayString(i.lastName), 9, _hoisted_68))
                              }), 256))
                            ], 512), [
                              [_vModelSelect, _ctx.selectedDetailedInvestigator]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("button", {
                              class: "btn btn-default transparent mr-2",
                              onClick: _cache[14] || (_cache[14] = $event => (_ctx.selectedDetailedInvestigator = {}))
                            }, "Back to investigation"),
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              onClick: _cache[15] || (_cache[15] = $event => (_ctx.assignInvestigator(_ctx.selectedDetailedInvestigator)))
                            }, "Assign investigator")
                          ])
                        ])
                      ]),
                      _createVNode(_component_NavigationBar, {
                        transparent: true,
                        navItems: _ctx.navItems,
                        onClickedNavItem: _ctx.clickedNavItem
                      }, null, 8, ["navItems", "onClickedNavItem"]),
                      _createElementVNode("div", _hoisted_70, [
                        (_ctx.selectedSection == 'Investigation list')
                          ? (_openBlock(), _createElementBlock("table", _hoisted_71, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings2, (h, index) => {
                                    return (_openBlock(), _createElementBlock("th", null, [
                                      _createElementVNode("p", null, _toDisplayString(h.text), 1)
                                    ]))
                                  }), 256))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_ctx.loadingAvailabilityContent)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [
                                      _createElementVNode("td", {
                                        colspan: _ctx.tableHeadings2.length
                                      }, [
                                        _createVNode(_component_LoadingIndicator)
                                      ], 8, _hoisted_73)
                                    ]))
                                  : (_ctx.errorLoadingAvailabilityContent)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                                        _createElementVNode("td", {
                                          colspan: _ctx.tableHeadings2.length
                                        }, [
                                          _createVNode(_component_ErrorIndicator)
                                        ], 8, _hoisted_75)
                                      ]))
                                    : (_ctx.investigations.length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                                          _createElementVNode("td", {
                                            colspan: _ctx.tableHeadings2.length
                                          }, "No Records", 8, _hoisted_77)
                                        ]))
                                      : (_ctx.investigations.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.investigations, (i) => {
                                            return (_openBlock(), _createElementBlock("tr", null, [
                                              _createElementVNode("td", _hoisted_78, _toDisplayString(i.latestPracticeLogData?.branchId == null ? i.latestPracticeLogData?.name : (i.latestPracticeLogData?.name
                        + ' - ' + i.latestPracticeLogData?.tradingName)), 1),
                                              _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.$formatDate(i.commencementDate)), 1),
                                              _createElementVNode("td", _hoisted_80, _toDisplayString(i.investigationType?.name), 1),
                                              _createElementVNode("td", _hoisted_81, _toDisplayString(i.investigationStatus?.name), 1)
                                            ]))
                                          }), 256))
                                        : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedSection == 'Calendar view')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.errorLoadingTimeEntries)
                                ? (_openBlock(), _createBlock(_component_ErrorIndicator, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_CalendarView, {
                                    key: 1,
                                    eventData: _ctx.eventData,
                                    viewSelector: true,
                                    todayButton: true,
                                    defaultView: "M",
                                    onUiDateTimeRangeChanged: _ctx.uiDateTimeRangeChanged
                                  }, {
                                    buttons: _withCtx(() => [
                                      (_ctx.loadingTimeEntries)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                            _createVNode(_component_LoadingIndicator, { showLoadingText: false })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["eventData", "onUiDateTimeRangeChanged"]))
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ], 64))
      ]),
      _: 1
    })
  ]))
}